import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalRendererComponent } from '../../widgets/modal-renderer/modal-renderer.component';

@Component({
    selector: 'app-custom-button',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ModalRendererComponent,
    ],
    templateUrl: './custom-button.component.html',
    styleUrl: './custom-button.component.css'
})
export class CustomButtonComponent {
  @Input() buttonResponse: any;
  @Input() btnFields: any;
  @Input() fields: any;
  @Input() isLoading: any;
  @Output() buttonClick = new EventEmitter<void>();
  modalTitle: any;
  activeModalContext: any;

  onClick(btn: any) {
    if (this.fields && this.fields.fieldDependencies) {
      const fieldDeps = this.fields.fieldDependencies;
      const onClickDep = fieldDeps.find(
        (dep: any) => dep.trigger === 'onClick'
      );

      if (onClickDep && Array.isArray(onClickDep.condition)) {
        for (const condBlock of onClickDep.condition) {
          const modalCond = condBlock.conditions?.find(
            (c: any) => c.type === 'form' && c.value
          );

          if (modalCond) {
            const modalContext = {
              nodeId: modalCond.targetValue,
            };
            return;
          }
        }
      }
    } else {
      this.buttonClick.emit(btn);
    }
  }

  closeOnBackdropClick(event: MouseEvent, id: string) {
    const modal = document.getElementById(id);
    if (event.target === modal) {
      this.closeModal();
    }
  }

  closeModal() {
    const modal = document.getElementById('domain_modal');
    if (modal) modal.classList.remove('show');
    this.activeModalContext = null;
  }

  onModalFormSaved(event: any): void {
    if (event?.success) {
      const modal = document.getElementById('domain_modal');
      if (modal) {
        modal.classList.remove('show');
      }
      this.activeModalContext = null;
    }
  }

  /** Function to set the modal title */
  setModalTitle(title: string) {
    this.modalTitle = title;
  }
}
